(function() {
  var AngularRouter,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AngularRouter = App.loadClass('core::Router');

  exports.Router = (function(superClass) {
    extend(Router, superClass);

    function Router() {
      return Router.__super__.constructor.apply(this, arguments);
    }

    Router.prototype.prefix = 'AR';

    Router.prototype.module_name = 'AdvisorRequestRouter';

    Router.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.service('grower::Angular/AdvisorRequest/Service', ['$http'], 'AdvisorService');
      this.controller('grower::Angular/AdvisorRequest/ManageController', ['$scope', '$transitions', '$uibModalInstance', 'AR.AdvisorService'], 'ManageController');
      return this.module.controller('AdvisorRequestController', [
        '$scope', '$uibModal', 'AR.AdvisorService', function($scope, $modal, $service) {
          return $service.fetchAdvisorRequest().then((function(_this) {
            return function(requests) {
              var dlg, newscope;
              if (requests.length !== 0) {
                newscope = $scope.$new();
                newscope.requests = requests;
                newscope.title = 'Respond to Connection Requests';
                return dlg = $modal.open({
                  templateUrl: 'backend/grower/advisor-request/layout',
                  controller: 'AR.ManageController',
                  scope: newscope
                });
              }
            };
          })(this));
        }
      ]);
    };

    return Router;

  })(AngularRouter);

}).call(this);
